<template>
  <div class="load-box" :style="{'height': getHeight}">
    <div class="loading" v-show="!isNoMore">
      <slot name="loading">{{loadingText}}</slot>
    </div>
    <div class="nomore" v-show="isNoMore">
      <slot name="nomore">
        <span class="iconfont">&#xe61d;</span>
        <p class="nomore-text">{{noMoreText}}</p>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      isNoMore: {
        type: Boolean,
        default: false
      },
      loadingText: {
        type: String,
        default: '正在加载数据。。。'
      },
      noMoreText: {
        type: String,
        default: '暂无相关数据'
      },
      height: {
        type: Number,
        default: '120px'
      }
    },
    computed: {
      getHeight () {
        return this.height < 100 ? '100px' : this.height + 'px'
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
  .load-box
    display table
    width 100%
    text-align center
    font-size 16px
    overflow hidden
    .loading, .nomore
      vertical-align middle
      display table-cell
    .nomore-text
      margin 0
    .iconfont
      font-size 70px
      line-height 70px
      color #999
</style>



// WEBPACK FOOTER //
// loading.vue?431c3928